import React, { Component } from 'react';
import { connect } from 'react-redux';

import FormulaireSelectionProjet from '../../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import Bouton from '../../../../UI/Bouton/Bouton';
import Interrupteur from '../../../../UI/Interrupteur/Interrupteur';

import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';

import { IsArrayString } from '../../../../../ressources/functionJS/IsArrayString';
import { jsDictionaryEquals } from '../../../../../ressources/functionJS/jsDictionaryEquals';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as glossaire_pattern from '../../../../../ressources/glossaires/glossaire_pattern';
import * as type_btn from '../../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../../../services/actions';

import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireRapportGabarit.module.scss';
import { AiOutlineCheck } from 'react-icons/ai';
import Collapse from '../../../../../hoc/Collapse/Collapse';
import FormulaireSelectionDateHeureUnix from '../../../../Graphe/ProfilGraphe/FormulaireGraphe/FormulaireSelectionDateHeureUnix/FormulaireSelectionDateHeureUnix';
import FormulaireListesObjetsRapport from './FormulaireListeObjetsRapport/FormulaireListeObjetsRapport';
import FormulaireSelectionTimeZone from '../../../../UI/FormulaireSelectionTimeZone/FormulaireSelectionTimeZone';
import FormulaireSelectionEmailgroup from '../../../../Capteur/Ajouter/FormulaireSelectionEmailgroup/FormulaireSelectionEmailgroup';
import FormulaireSaisieDuree from '../../../../UI/FormulaireSaisieDurée/FormulaireSaisieDuree';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../../UI/MessageErreur/MessageErreur';
import {
  schemaNouveauRapportGabarit,
  schemaModificationRapportGabarit,
  schemaStylePolice,
} from '../../../../../services/schemas/rapportGabarit';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../../services/schemas/validerFormulaire';

class FormulaireRapportGabarit extends Component {
  state = {
    //Information générale
    // project_id: this.props.preconfigurerRapportGabarit !== undefined && this.props.preconfigurerRapportGabarit.project_id !== undefined ? this.props.preconfigurerRapportGabarit.project_id : null,
    time_zone:
      this.props.preconfigurerRapportGabarit?.time_zone || 'Europe/Paris',
    email_group_id:
      this.props.preconfigurerRapportGabarit?.email_group_id || null,
    interval_next_generation:
      this.props.preconfigurerRapportGabarit?.interval_next_generation || null,
    last_unixtimestamp_run:
      this.props.preconfigurerRapportGabarit?.last_unixtimestamp_run || null,
    next_unixtimestamp_run:
      this.props.preconfigurerRapportGabarit?.next_unixtimestamp_run || null,
    mode: this.props.preconfigurerRapportGabarit?.mode || 0,
    enable: this.props.preconfigurerRapportGabarit?.enable || 0,
    publication_auto:
      this.props.preconfigurerRapportGabarit?.publication_auto || 0,
    pdf_result: this.props.preconfigurerRapportGabarit?.pdf_result || 0,
    number_of_days: this.props.preconfigurerRapportGabarit?.number_of_days || 0,
    show_summary: this.props.preconfigurerRapportGabarit?.show_summary || false,
    erreurs: {},
  };

  componentDidMount() {
    if (
      this.props !== undefined &&
      this.props.preconfigurerRapportGabarit !== undefined
    ) {
      this.setState({
        ...this.props.preconfigurerRapportGabarit,
      });
    }
    if (this.props.configurationRapportGabarit !== undefined) {
      this.setState({ ...this.props.configurationRapportGabarit });
    } else {
      this.setState({
        graphical_charter: {
          page_header: { omit_cover_page: 1, objects_list: [] },
          page_footer: { omit_cover_page: 1, objects_list: [] },
          font_style: {
            family: 'Montserrat',
            style: 'italic',
            weight: 2,
            line_height: 'normal',
            size: 2,
          },
        },
        cover_page: {
          cover_centered: 1,
          objects_list: [],
        },
        body_page: { objects_list: [] },
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props !== undefined &&
      this.props.preconfigurerRapportGabarit !== undefined &&
      !jsDictionaryEquals(
        prevProps.preconfigurerRapportGabarit,
        this.props.preconfigurerRapportGabarit
      )
    ) {
      this.setState({
        ...this.props.preconfigurerRapportGabarit,
      });
    }
    if (
      this.props !== undefined &&
      this.props.configurationRapportGabarit !== undefined &&
      (!jsDictionaryEquals(
        this.props.configurationRapportGabarit,
        prevProps.configurationRapportGabarit
      ) ||
        this.props.preconfigurerRapportGabarit.file_path !==
          prevProps.preconfigurerRapportGabarit.file_path)
    ) {
      this.setState({
        graphical_charter:
          this.props.configurationRapportGabarit.graphical_charter,
        cover_page: this.props.configurationRapportGabarit.cover_page,
        body_page: this.props.configurationRapportGabarit.body_page,
        show_summary:
          this.props.configurationRapportGabarit.summary !== undefined,
      });
    }
  }

  gererEnvoi = () => {
    //mise en forme de l'objet pour l'envoi de la requête API

    // La charte graphique part sérialisée dans json_config. Ses nombres sont
    // donc contrôlés à part : sans cela, le message d'erreur ressortirait sous
    // la clé json_config, que le formulaire n'affiche nulle part, au lieu de se
    // poser sous la graisse ou la taille fautive.
    const stylePolice = this.state.graphical_charter?.font_style;
    const police = stylePolice
      ? validerFormulaire(schemaStylePolice, stylePolice)
      : { valide: true, donnees: stylePolice, erreurs: {} };

    let json_config = {
      graphical_charter: {
        ...this.state.graphical_charter,
        // Les nombres ressortent convertis du schéma. parseInt le faisait
        // avant, mais rendait NaN pour une saisie illisible, que
        // JSON.stringify écrivait alors en null sans rien signaler.
        font_style: police.valide ? police.donnees : stylePolice,
      },
      cover_page: {
        ...this.state.cover_page,
      },
      body_page: {
        ...this.state.body_page,
      },
    };
    if (this.state.show_summary === true) {
      json_config['summary'] = {
        objects_list: [
          {
            summary_title: 'Sommaire',
            family: 'Montserrat',
            size: 'italic',
            bold: true,
            italic: false,
            pagebreak: true,
          },
        ],
      };
    } else {
      delete json_config['summary'];
    }

    // Les champs partent tels que saisis : le schéma les convertit, et
    // distingue un champ vide d'une saisie illisible, ce que parseInt ne
    // faisait pas, les ramenant tous les deux à NaN puis à null.
    let formulaireRapportGabarit = {
      //clé du formulaire de rapport gabarit de l'api
      project_id: this.state.project_id,
      name: this.state.name,
      time_zone: this.state.time_zone,
      email_group_id: this.state.email_group_id,
      interval_next_generation: this.state.interval_next_generation,
      last_unixtimestamp_run: this.state.last_unixtimestamp_run,
      next_unixtimestamp_run: this.state.next_unixtimestamp_run,
      mode: this.state.mode,
      enable: this.state.enable,
      publication_auto: this.state.publication_auto,
      pdf_result: this.state.pdf_result,
      number_of_days: this.state.number_of_days,
      json_config: JSON.stringify(json_config),
    };

    //Envoi la requête de création des rapports gabarits si les rapports
    //gabarits n'ont pas de pré-remplissage des champs du formulaire, sinon
    //modification
    const enCreation =
      this.props !== undefined &&
      this.props.preconfigurerRapportGabarit === undefined;
    if (!enCreation) {
      formulaireRapportGabarit['template_report_id'] =
        this.props.preconfigurerRapportGabarit.template_report_id;
    }

    const { valide, donnees, erreurs } = validerFormulaire(
      enCreation
        ? schemaNouveauRapportGabarit
        : schemaModificationRapportGabarit,
      formulaireRapportGabarit
    );
    // Les deux jeux d'erreurs sont affichés ensemble : corriger la graisse pour
    // découvrir ensuite qu'il manque le nom ferait faire deux tours.
    this.setState({ erreurs: { ...erreurs, ...police.erreurs } });
    if (!valide || !police.valide) {
      return;
    }

    if (enCreation) {
      this.props.reqCreerRapportGabarit(donnees);
    } else {
      this.props.reqModifierRapportGabarit(donnees);
    }
  };
  gererEtatDeCibleName = (event) =>
    this.setState({ [event.target.name]: event.target.value });
  gererEtatDeCibleNameStylePolice = (event) =>
    this.setState({
      graphical_charter: {
        ...this.state.graphical_charter,
        font_style: {
          ...this.state.graphical_charter.font_style,
          [event.target.name]: event.target.value,
        },
      },
    });
  gererArrayEtatDeCibleName = (event) =>
    this.setState({
      [event.target.name]: IsArrayString(event.target.value),
    });
  // Aucun setState de ce composant ne recopie this.state : setState fusionne
  // déjà. La copie était dangereuse ici. FormulaireSelectionProjet appelle
  // gererProjetId depuis son useEffect au montage, avant que React 17
  // n'applique la pré-configuration mise en file par componentDidMount ;
  // { ...this.state, project_id } repartait alors de l'état initial.
  gererProjetId = (projetId) => this.setState({ project_id: projetId });
  // enable, publication_auto et pdf_result : l'Interrupteur renvoie 0 ou 1
  // et le nom du champ.
  gererInterrupteur = (valeur, nom) => this.setState({ [nom]: valeur });
  gererTimeZone = (time_zone) => this.setState({ time_zone: time_zone });
  // Le nom d'état sert aussi de clé d'erreur : le schéma et le formulaire
  // nomment les champs pareil, si bien que chaque input affiche son message
  // sans qu'il faille l'y brancher un par un.
  erreurDuChamp = (label_state) =>
    messageDuChamp(this.state.erreurs, label_state);
  // Ouvre la section qui contient un champ en faute : à la création,
  // affichageProfil vaut undefined et les sections de la charte graphique sont
  // repliées, si bien que le message s'afficherait sans que rien ne se voie.
  ouvrirSiErreur = (champs) =>
    champs.some((champ) => this.erreurDuChamp(champ))
      ? true
      : this.props.affichageProfil === false;
  affichageFormulaire = (style, label_state, label_name, pattern) => {
    /**
     * permet d'afficher un composant input de gestion de la modification
     */
    const erreur = this.erreurDuChamp(label_state);

    switch (pattern) {
      case glossaire_pattern.array:
        return (
          <div className={`${s.col_6} ${styles.style}`}>
            <span className={styles.stil2}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={`${s.form_control} ${erreur ? classeChampEnErreur : ''}`}
              placeholder={label_state}
              name={label_state}
              value={this.state[label_state] || ''}
              disabled={this.props.affichageProfil === true}
              onChange={this.gererArrayEtatDeCibleName}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
      default:
        return (
          <div className={`${style} ${styles.style}`}>
            <span className={styles.stil2}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={`${s.form_control} ${erreur ? classeChampEnErreur : ''}`}
              placeholder={label_state}
              name={label_state}
              value={this.state[label_state] || ''}
              disabled={this.props.affichageProfil === true}
              onChange={this.gererEtatDeCibleName}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
    }
  };
  affichageFormulaireStylePolice = (
    style,
    label_state,
    label_name,
    pattern
  ) => {
    /**
     * permet d'afficher un composant input de gestion de la modification
     */
    const erreur = this.erreurDuChamp(label_state);
    // À la création, value valait null : l'input basculait en non contrôlé et
    // n'affichait pas la valeur par défaut de la charte, pourtant bien celle
    // qui part à l'envoi. On lit l'état dans les deux cas.
    const valeur = this.state.graphical_charter?.font_style?.[label_state];

    switch (pattern) {
      case glossaire_pattern.array:
        return (
          <div className={[s.col_6, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[
                s.form_control,
                erreur ? classeChampEnErreur : '',
              ].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={valeur === undefined ? '' : JSON.stringify(valeur)}
              disabled={this.props.affichageProfil === true}
              onChange={(event) => this.gererEtatDeCibleNameStylePolice(event)}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
      default:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={[
                s.form_control,
                erreur ? classeChampEnErreur : '',
              ].join(' ')}
              placeholder={label_state}
              name={label_state}
              value={valeur === undefined || valeur === null ? '' : valeur}
              disabled={this.props.affichageProfil === true}
              onChange={(event) => this.gererEtatDeCibleNameStylePolice(event)}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
    }
  };
  gererLast_unixtimestamp_run = (unix) =>
    this.setState({ last_unixtimestamp_run: unix });
  gererNext_unixtimestamp_run = (unix) =>
    this.setState({ next_unixtimestamp_run: unix });
  // Ces trois gestionnaires reçoivent 0 ou 1 de l'Interrupteur. Les listes
  // déroulantes qui précédaient transmettaient event.target.value : pour
  // omit_cover_page, la chaîne "0" ou "1" partait ainsi dans json_config,
  // alors que la valeur par défaut est le nombre 1.
  gererPage_headerOmit_cover_page = (valeur) =>
    this.setState({
      graphical_charter: {
        ...this.state.graphical_charter,
        page_header: {
          ...this.state.graphical_charter.page_header,
          omit_cover_page: valeur,
        },
      },
    });
  gererPage_footerOmit_cover_page = (valeur) =>
    this.setState({
      graphical_charter: {
        ...this.state.graphical_charter,
        page_footer: {
          ...this.state.graphical_charter.page_footer,
          omit_cover_page: valeur,
        },
      },
    });
  gererCover_pageCover_centered = (valeur) =>
    this.setState({
      cover_page: {
        ...this.state.cover_page,
        cover_centered: valeur,
      },
    });
  gererPage_headerObject_list = (objects_list) =>
    this.setState({
      graphical_charter: {
        ...this.state.graphical_charter,
        page_header: {
          ...this.state.graphical_charter.page_header,
          objects_list: [...objects_list],
        },
      },
    });
  gererPage_footerObject_list = (objects_list) =>
    this.setState({
      graphical_charter: {
        ...this.state.graphical_charter,
        page_footer: {
          ...this.state.graphical_charter.page_footer,
          objects_list: [...objects_list],
        },
      },
    });
  gererCover_pageObject_list = (objects_list) =>
    this.setState({
      cover_page: { objects_list: [...objects_list] },
    });
  gererBody_pageObject_list = (objects_list) =>
    this.setState({
      body_page: { objects_list: [...objects_list] },
    });
  gererEmailgroupId = (emailgroupId) =>
    this.setState({ email_group_id: emailgroupId });
  gererIntervalNextGeneration = (interval_next_generation) =>
    this.setState({
      interval_next_generation: parseInt(interval_next_generation),
    });

  render() {
    const barre_outil =
      this.props.affichageProfil === true ? null : (
        <div className={s.form_group}>
          <div className={[s.d_flex, s.justify_content_between].join(' ')}>
            <div>
              <Bouton
                type={type_btn.danger}
                cliquer={(e) => {
                  e.preventDefault();
                  this.props.annuler();
                }}
              >
                {checkMot('annuler')}
              </Bouton>
            </div>
            <div className={[s.d_flex, s.justify_content_between].join(' ')}>
              {this.props !== undefined &&
              this.props.preconfigurerRapportGabarit === undefined ? (
                <AttenteRequete
                  request_type={requestType.creer_un_rapport_gabarit}
                  str={checkMot('creation_en_cour')}
                >
                  <Bouton
                    type={type_btn.succes}
                    ajoutClass={styles.Bts}
                    cliquer={() => this.gererEnvoi()}
                  >
                    <AiOutlineCheck />
                    {checkMot('creer')}
                  </Bouton>
                </AttenteRequete>
              ) : (
                <AttenteRequete
                  request_type={requestType.modifier_un_rapport_gabarit}
                  str={checkMot('modification_en_cour')}
                >
                  <Bouton
                    type={type_btn.succes}
                    cliquer={() => this.gererEnvoi()}
                  >
                    {checkMot('enregistrer')}
                  </Bouton>
                </AttenteRequete>
              )}
            </div>
          </div>
        </div>
      );
    return (
      <>
        <form
          className={`${styles.formulaire} ${styles.boxing}`}
          onSubmit={(event) => event.preventDefault()}
          noValidate
        >
          <Collapse
            showAdvanceParameters={true}
            expandText={checkMot('info_general')}
          >
            <div className={s.form_group}>
              <div className={`${s.form_row} ${s.text_left}`}>
                {/**DEBUT project_id**/}
                <FormulaireSelectionProjet
                  affichageProfil={this.props.affichageProfil}
                  gererProjetId={this.gererProjetId}
                  preconfigurerProjetId={this.state.project_id}
                />
                <MessageErreur cle={this.erreurDuChamp('project_id')} />
                {/**FIN project_id**/}
                {/**DEBUT name**/}
                {this.affichageFormulaire(
                  s.col_12,
                  'name',
                  checkMot('name'),
                  glossaire_pattern.text
                )}
                {/**FIN name**/}
                {/**DEBUT time_zone**/}

                <div className={[s.col_12, styles.style].join(' ')}>
                  <FormulaireSelectionTimeZone
                    affichageProfil={this.props.affichageProfil}
                    gererTimeZone={this.gererTimeZone}
                    preconfigurerTimeZone={this.state.time_zone}
                  />
                </div>
                {/**FIN time_zone**/}
                {/**DEBUT last_unixtimestamp_run next_unixtimestamp_run**/}

                <div className={[s.form_group, s.text_center].join(' ')}>
                  <div className={[s.form_row, s.align_items_center].join(' ')}>
                    <span className={[styles.stil2, s.col_12].join(' ')}>
                      {' '}
                      {checkMot('derniere_generation')}
                    </span>
                    <div className={s.col_12}>
                      {/**DEBUT last_unixtimestamp_run**/}
                      <FormulaireSelectionDateHeureUnix
                        value={this.state.last_unixtimestamp_run}
                        gereUnixDate={this.gererLast_unixtimestamp_run}
                        disabled={this.props.affichageProfil === true}
                      />
                      {/**FIN last_unixtimestamp_run**/}
                    </div>
                    <span className={[styles.stil2, s.col_12].join(' ')}>
                      {' '}
                      {checkMot('prochaine_generation')}
                    </span>
                    <div className={s.col_12}>
                      {/**DEBUT next_unixtimestamp_run**/}
                      <FormulaireSelectionDateHeureUnix
                        value={this.state.next_unixtimestamp_run}
                        gereUnixDate={this.gererNext_unixtimestamp_run}
                        disabled={this.props.affichageProfil === true}
                      />
                      {/**FIN next_unixtimestamp_run**/}
                    </div>
                  </div>
                </div>
                {/**FIN last_unixtimestamp_run next_unixtimestamp_run**/}
                {/**DEBUT mode**/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <span className={[styles.stil2].join(' ')}>
                    {checkMot('mode')}
                  </span>
                  <select
                    onChange={(event) => this.gererEtatDeCibleName(event)}
                    defaultValue={this.state.mode}
                    disabled={this.props.affichageProfil === true}
                    value={this.state.mode}
                    name={'mode'}
                    className={[s.custom_select].join(' ')}
                  >
                    <option value={0}>0: {checkMot('jour')}</option>
                    <option value={1}>1: {checkMot('mensuel')}</option>
                  </select>
                </div>
                {/**FIN mode**/}
                {/**DEBUT enable**/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <Interrupteur
                    name="enable"
                    label={checkMot('enable')}
                    valeur={this.state.enable}
                    disabled={this.props.affichageProfil === true}
                    onChange={this.gererInterrupteur}
                  />
                </div>
                {/**FIN enable**/}
                {/**DEBUT number_of_days**/}
                {this.affichageFormulaire(
                  s.col_6,
                  'number_of_days',
                  checkMot('number_of_days'),
                  glossaire_pattern.integer
                )}
                {/**FIN number_of_days**/}
                {/**DEBUT email_group_id**/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <FormulaireSelectionEmailgroup
                    affichageProfil={this.props.affichageProfil}
                    gererEmailgroupId={this.gererEmailgroupId}
                    preconfigurerEmailgroupId={this.state.email_group_id}
                  />
                </div>
                {/**FIN email_group_id**/}
                {/**DEBUT interval_next_generation**/}
                {/*{this.affichageFormulaire(s.col_6, "interval_next_generation", checkMot("interval_next_generation"), glossaire_pattern.integer)}*/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <span className={[styles.stil2].join(' ')}>
                    {checkMot('interval_next_generation')}
                  </span>
                  <FormulaireSaisieDuree
                    affichageProfil={this.props.affichageProfil}
                    gererDuree={this.gererIntervalNextGeneration}
                    preconfigurerDuree={this.state.interval_next_generation}
                  />
                  <MessageErreur
                    cle={this.erreurDuChamp('interval_next_generation')}
                  />
                </div>
                {/**FIN interval_next_generation**/}
                {/**DEBUT publication_auto**/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <Interrupteur
                    name="publication_auto"
                    label={checkMot('publication_auto')}
                    valeur={this.state.publication_auto}
                    disabled={this.props.affichageProfil === true}
                    onChange={this.gererInterrupteur}
                  />
                </div>
                {/**FIN publication_auto**/}
                {/**DEBUT pdf_result**/}
                <div className={[s.col_6, styles.style].join(' ')}>
                  <Interrupteur
                    name="pdf_result"
                    label={checkMot('pdf_result')}
                    valeur={this.state.pdf_result}
                    disabled={this.props.affichageProfil === true}
                    onChange={this.gererInterrupteur}
                  />
                </div>
                {/**FIN pdf_result**/}
              </div>
            </div>
            {barre_outil}
          </Collapse>
        </form>
        <form
          className={[styles.formulaire, styles.chart_graph].join(' ')}
          onSubmit={(event) => event.preventDefault()}
          noValidate
        >
          <Collapse
            showAdvanceParameters={this.props.affichageProfil === false}
            expandText={checkMot('sommaire')}
          >
            <span
              onClick={() =>
                this.setState({ show_summary: !this.state.show_summary })
              }
            >
              <input
                checked={this.state.show_summary}
                disabled={this.props.affichageProfil === true}
                type={'checkbox'}
              />{' '}
              {this.state.show_summary
                ? checkMot('afficher_le_sommaire')
                : checkMot('ne_pas_afficher_le_sommaire')}
            </span>
          </Collapse>
          {this.state.graphical_charter !== undefined ? (
            <Collapse
              showAdvanceParameters={this.ouvrirSiErreur(['weight', 'size'])}
              expandText={checkMot('charte_graphique')}
            >
              <form
                className={[styles.formulaire, styles.haut_page].join(' ')}
                onSubmit={(event) => event.preventDefault()}
                noValidate
              >
                <Collapse
                  showAdvanceParameters={this.props.affichageProfil === false}
                  expandText={checkMot('haut_de_page')}
                >
                  {/**DEBUT omit_cover_page**/}
                  <div className={[s.col_12, styles.style].join(' ')}>
                    <span className={[styles.stil2].join(' ')}>
                      {checkMot('premiere_page')}
                    </span>
                    <Interrupteur
                      name="omit_cover_page_haut"
                      label={checkMot('omettre_la_premiere_page')}
                      valeur={
                        this.state.graphical_charter.page_header.omit_cover_page
                      }
                      disabled={this.props.affichageProfil === true}
                      onChange={this.gererPage_headerOmit_cover_page}
                    />
                  </div>
                  {/**FIN omit_cover_page**/}
                  {barre_outil}

                  <Collapse
                    showAdvanceParameters={this.props.affichageProfil === false}
                    expandText={checkMot('objects_list')}
                  >
                    <FormulaireListesObjetsRapport
                      project_id={this.state.project_id}
                      affichageProfil={this.props.affichageProfil}
                      gererObjectsList={this.gererPage_headerObject_list}
                      objects_list={
                        this.state.graphical_charter.page_header.objects_list
                      }
                    />
                  </Collapse>
                </Collapse>
              </form>
              <form
                className={[styles.formulaire, styles.bas_page].join(' ')}
                onSubmit={(event) => event.preventDefault()}
                noValidate
              >
                <Collapse
                  showAdvanceParameters={this.props.affichageProfil === false}
                  expandText={checkMot('bas_de_page')}
                >
                  {/**DEBUT omit_cover_page**/}
                  <div className={[s.col_12, styles.style].join(' ')}>
                    <span className={[styles.stil2].join(' ')}>
                      {checkMot('premiere_page')}
                    </span>
                    <Interrupteur
                      name="omit_cover_page_bas"
                      label={checkMot('omettre_la_premiere_page')}
                      valeur={
                        this.state.graphical_charter.page_footer.omit_cover_page
                      }
                      disabled={this.props.affichageProfil === true}
                      onChange={this.gererPage_footerOmit_cover_page}
                    />
                  </div>
                  {/**FIN omit_cover_page**/}
                  {barre_outil}

                  <Collapse
                    showAdvanceParameters={this.props.affichageProfil === false}
                    expandText={checkMot('objects_list')}
                  >
                    <FormulaireListesObjetsRapport
                      project_id={this.state.project_id}
                      affichageProfil={this.props.affichageProfil}
                      gererObjectsList={this.gererPage_footerObject_list}
                      objects_list={
                        this.state.graphical_charter.page_footer.objects_list
                      }
                    />
                  </Collapse>
                </Collapse>
              </form>
              <form
                className={[styles.formulaire, styles.config].join(' ')}
                onSubmit={(event) => event.preventDefault()}
                noValidate
              >
                <Collapse
                  showAdvanceParameters={this.ouvrirSiErreur([
                    'weight',
                    'size',
                  ])}
                  expandText={checkMot('style_de_police')}
                >
                  {/**DEBUT family**/}
                  <div className={[s.col_12, styles.style].join(' ')}>
                    <span className={[styles.stil2].join(' ')}>
                      {checkMot('famille_de_police')}
                    </span>
                    <select
                      onChange={(event) =>
                        this.gererEtatDeCibleNameStylePolice(event)
                      }
                      defaultValue={
                        this.state.graphical_charter.font_style.family
                      }
                      disabled={this.props.affichageProfil === true}
                      value={this.state.graphical_charter.font_style.family}
                      name={'family'}
                      className={[s.custom_select].join(' ')}
                    >
                      <option value={'Verdana'}>{'Verdana'}</option>
                      <option value={'Franklin book'}>{'Franklin book'}</option>
                      <option value={'Montserrat'}>{'Montserrat'}</option>
                      <option value={'Arial'}>{'Arial'}</option>
                    </select>
                  </div>
                  {/**FIN family**/}
                  {/**DEBUT style**/}
                  <div className={[s.col_12, styles.style].join(' ')}>
                    <span className={[styles.stil2].join(' ')}>
                      {checkMot('famille_de_police')}
                    </span>
                    <select
                      onChange={(event) =>
                        this.gererEtatDeCibleNameStylePolice(event)
                      }
                      defaultValue={
                        this.state.graphical_charter.font_style.style
                      }
                      disabled={this.props.affichageProfil === true}
                      value={this.state.graphical_charter.font_style.style}
                      name={'style'}
                      className={[s.custom_select].join(' ')}
                    >
                      <option value={'normal'}>{'normal'}</option>
                      <option value={'italic'}>{'italic'}</option>
                    </select>
                  </div>
                  {/**FIN style**/}
                  {/**DEBUT weight**/}
                  {this.affichageFormulaireStylePolice(
                    s.col_12,
                    'weight',
                    checkMot('weight'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN weight**/}
                  {/**DEBUT line_height**/}
                  {this.affichageFormulaireStylePolice(
                    s.col_12,
                    'line_height',
                    checkMot('line_height'),
                    glossaire_pattern.text
                  )}
                  {/**FIN line_height**/}
                  {/**DEBUT size**/}
                  {this.affichageFormulaireStylePolice(
                    s.col_12,
                    'size',
                    checkMot('size'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN size**/}
                  {barre_outil}
                </Collapse>
              </form>
            </Collapse>
          ) : (
            this.setState({
              graphical_charter: {
                page_header: { omit_cover_page: 1, objects_list: [] },
                page_footer: { omit_cover_page: 1, objects_list: [] },
                font_style: {
                  family: 'Montserrat',
                  style: 'italic',
                  weight: 2,
                  line_height: 'normal',
                  size: 2,
                },
              },
            })
          )}
          {this.state.cover_page !== undefined ? (
            <Collapse
              showAdvanceParameters={this.props.affichageProfil === false}
              expandText={checkMot('cover_page')}
            >
              {/**DEBUT cover_centered**/}
              <div className={[s.col_12, styles.style].join(' ')}>
                <Interrupteur
                  name="cover_centered"
                  label={checkMot('centrer_la_page_de_garde')}
                  valeur={this.state.cover_page.cover_centered}
                  disabled={this.props.affichageProfil === true}
                  onChange={this.gererCover_pageCover_centered}
                />
              </div>
              {/**FIN cover_centered**/}
              <FormulaireListesObjetsRapport
                project_id={this.state.project_id}
                affichageProfil={this.props.affichageProfil}
                gererObjectsList={this.gererCover_pageObject_list}
                objects_list={this.state.cover_page.objects_list}
              />
            </Collapse>
          ) : (
            this.setState({
              cover_page: { cover_centered: 1, objects_list: [] },
            })
          )}
          {this.state.body_page !== undefined ? (
            <Collapse
              showAdvanceParameters={this.props.affichageProfil === false}
              expandText={checkMot('body_page')}
            >
              <FormulaireListesObjetsRapport
                project_id={this.state.project_id}
                affichageProfil={this.props.affichageProfil}
                gererObjectsList={this.gererBody_pageObject_list}
                objects_list={this.state.body_page.objects_list}
              />
            </Collapse>
          ) : (
            this.setState({ body_page: { objects_list: [] } })
          )}
          {barre_outil}
        </form>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reqCreerRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqCreerRapportGabarit(formulaireRapportGabarit)),
    reqModifierRapportGabarit: (formulaireRapportGabarit) =>
      dispatch(actions.reqModifierRapportGabarit(formulaireRapportGabarit)),
  };
};

export default connect(null, mapDispatchToProps)(FormulaireRapportGabarit);
